export default "__VITE_ASSET__BDF6nH8q__"